import classNames from "classnames";
import styles from "./index.module.scss"
import MainTitle from "@/components/MainTitle";
const ContactTitle = () => {
	return <div className={classNames('container', styles.contactTitleBox)}>
		<MainTitle title="CONTACT US" />
	</div>
}
export default ContactTitle